export default "__VITE_ASSET__98d9b3bc__"